import React from "react";

export const CryptoWeeklyIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_17454_52603)">
            <path
                d="M13.9997 1.33203H1.99967C1.63148 1.33203 1.33301 1.63051 1.33301 1.9987V13.9987C1.33301 14.3669 1.63148 14.6654 1.99967 14.6654H13.9997C14.3679 14.6654 14.6663 14.3669 14.6663 13.9987V1.9987C14.6663 1.63051 14.3679 1.33203 13.9997 1.33203Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.33301 4.66797H14.6663"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.33301 3.66797V7.66797"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6665 3.66797V7.66797"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.09899 12.668L8.44558 8.02024V7.98331H5.70126V6.84979H9.90012V7.99183L7.54501 12.668H6.09899Z"
                fill="#77808D"
            />
        </g>
        <defs>
            <clipPath id="clip0_17454_52603">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
